import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { TableCell, Theme } from '@material-ui/core';

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    borderRight: '1px #CCCCCC solid'
  },
  body: {
    fontSize: 16,
    padding: 0,
    height: 60,
    borderRight: '1px #CCCCCC solid'
  }
}))(TableCell);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subContainer: {
      marginLeft: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    inputMainContainer: {
      display: 'flex',
      backgroundColor: '#F5F5F5',
      height: 60,
      alignItems: 'center',
      width: '100%'
    },
    inputContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%'
    },
    inputMainItemQuantity: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    inputAllCostPriceContainer: {
      marginLeft: 10,
      paddingRight: 3,
      width: '100%'
    },
    inputDetailContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    inputQuantityContainer: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      width: '100%',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center'
    },
    textMainContainer: {
      display: 'flex',
      backgroundColor: '#0099CC', //MainBlueColor
      width: '50%',
      height: 60,
      alignItems: 'center'
    },
    textContainer: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    },
    textContainerMainItem: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14,
      paddingLeft: 8
    },
    input: {
      height: 40,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    text: {
      fontSize: 18,
      fontWeight: 'bold',
      marginBottom: 10,
      marginLeft: 15
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#0099CC !important`, //MainBlueColor
      color: '#FFFFFF',
      fontWeight: 'bold'
    },
    inputBottom: {
      height: 30,
      width: '100%',
      borderColor: '#c1c1c1',
      borderWidth: 1
    },
    inputContainerSelectBox: {
      marginLeft: 10,
      marginRight: 13,
      width: '100%'
    },
    textContainerPrice: {
      marginLeft: 10,
      marginRight: 10,
      paddingRight: 10,
      textAlign: 'right',
      width: '100%'
    },
    selectBoxStyle: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 38,
      width: '70%'
    },
    selectLayerType: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 38,
      width: '80%'
    },
    selectBoxCost: {
      WebkitAppearance: 'menulist-button',
      borderColor: '#c1c1c1',
      height: 38,
      width: '70%',
      color: 'blue'
    },
    multiLinesTable: {
      padding: 0,
      backgroundColor: `#0099CC !important`, //MainBlueColor
      color: '#FFFFFF',
      fontWeight: 'bold'
    },
    multiColCell: {
      width: '50%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    subTableHead: {
      padding: 8,
      borderBottom: '1px #0099CC solid'
    },
    subCell: {
      padding: 8,
      borderBottom: '1px #F5F5F5 solid'
    },
    subCostCell: {
      padding: 8,
      borderBottom: '1px #CCCCCC solid'
    },
    input1: {
      height: 60,
      width: '100%'
    },
    input2: {
      height: 40,
      width: '100%'
    },
    tableTextArea: {
      height: 100,
      width: 250
    },
    tableBody: {
      backgroundColor: '#F5F5F5'
    },
    smallInput: {
      height: 30,
      width: 80
    },
    smallQuantityInput: {
      height: 30,
      width: 80,
      textAlign: 'right'
    },
    smallCostInput: {
      height: 30,
      width: 80,
      color: 'blue'
    },
    smallCostQuantityInput: {
      height: 30,
      width: 80,
      color: 'blue',
      textAlign: 'right'
    },
    smallMemoInput: {
      height: 40,
      width: '100%',
      color: 'blue',
      marginTop:10,
    },
    breadcrumbsArea: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    breadcrumbs: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: 16
    },
    itemNames: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginLeft: 12
    },
    addText: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      fontSize: 14,
      marginTop: 10,
      marginRight: 350,
      textDecoration: 'Underline'
    }
  })
);
